var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { SelectedListModel } from './types/selected-list-model.interface';
let SelectedListServiceImpl = class SelectedListServiceImpl {
    constructor(_selectedListModel) {
        this._selectedListModel = _selectedListModel;
    }
    updateSelectedList(selectedList) {
        this._selectedListModel.updateSelectedList(selectedList);
    }
    addBatchSelectedItems(ids) {
        this._selectedListModel.addBatchSelectedItems(ids);
    }
    addSelectedItem(id) {
        this._selectedListModel.addSelectedItem(id);
    }
    removeBatchSelectedItems(ids) {
        this._selectedListModel.removeBatchSelectedItems(ids);
    }
    removeSelectedItem(id) {
        this._selectedListModel.removeSelectedItem(id);
    }
    clearSelectedList() {
        this._selectedListModel.clearSelectedList();
    }
    getSelectedList() {
        return this._selectedListModel.getSelectedList();
    }
    checkIsSelected(id) {
        return this._selectedListModel.checkIsSelected(id);
    }
    subscribe(callback) {
        return this._selectedListModel.subscribe(callback);
    }
};
SelectedListServiceImpl = __decorate([
    injectable(),
    __param(0, inject(SelectedListModel)),
    __metadata("design:paramtypes", [typeof (_a = typeof SelectedListModel !== "undefined" && SelectedListModel) === "function" ? _a : Object])
], SelectedListServiceImpl);
export { SelectedListServiceImpl };
